import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import News from "../News";
import HTMLEditor from "../HtmlEditior/HTMLEditor";

const CreateNews = () => {
  const navigate = useNavigate();
  const [editorContent, setEditorContent] = useState("");
  const [isloading, setLoading] = useState(false);
  const [modalid, setModalid] = useState("");
  const [modelDetails, setModelDetails] = useState(null);

  const userId = useSelector((state) => state.auth.userId);
  const Id = useParams();
  const newsId = Id?.id;
  const editorRef = useRef(null);
  const handleEditorReady = (editor) => {
    editorRef.current = editor;
  };

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const handleSave = (content) => {
    console.log("Content saved:", content);
  };
  const [newsData, setNewsData] = useState({
    title: "",
    image: null,
    source: "",
    news_category: "",
    image_mime_type: null,
    image_alt: null,
    banner_image: null,
    slug_url: "",
    meta_title: null,
    meta_keywords: null,
    meta_description: null,
    short_description: null,
    description: null,
    source: "",
  });

  useEffect(() => {
    if (newsId) {
      handleShowDetails(newsId);
    }
  }, [newsId]);

  const handleChange = (e) => {
    setNewsData({ ...newsData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const requestData = {
      created_by: userId,
      ...newsData,
      show_quote_button: "0",
      status: "publish",
      description: editorContent,
    };

    try {
      const response = await fetch(
        "https://api.greymatterz.com/api/v1/create-news",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        //console.log("Model created successfully");
        setLoading(false);
        // setShow(false);
        // fetchNews();
        navigate("/News");
      } else {
        setLoading(false);
        // console.error("Failed to create model");
      }
    } catch (error) {
      console.error("Error creating model:", error);
    }
  };

  const handleShowDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/admin/get-news/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("data", data);
      setLoading(false);

      setModelDetails(data.data);
      setNewsData(data.data || {});
      setEditorContent(data.data.description || "");
      setModalid(data?.data?._id);
      // setDetailShow(true);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching model details:", error);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const requestData = {
      created_by: userId,
      title: newsData.title,
      short_description: newsData.short_description,
      createdAt: newsData.createdAt,
      slug_url: newsData.slug_url,
      by_message: newsData.by_message,
      meta_tags: newsData.meta_tags,
      description: editorContent,
      meta_title: newsData.meta_title,
      meta_keywords: newsData.meta_keywords,
      meta_description: newsData.meta_description,
    };

    //console.log(requestData);

    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/update-news/${modelDetails._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        //console.log("Model updated successfully");
        setLoading(false);

        navigate("/News");
      } else {
        console.error("Failed to update model");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating model:", error);
    }
  };

  return (
    <div className="news-form-container">
      <h2>Create News</h2>
      <div>
        {/* Title Input */}
        <input
          type="text"
          name="title"
          placeholder="Title"
          className="news-input"
          value={newsData.title}
          onChange={handleChange}
        />

        {/* Short Description Input */}
        <textarea
          name="short_description"
          placeholder="Short Description"
          className="news-input news-textarea"
          value={newsData.short_description}
          onChange={handleChange}
        />

        {/* HTML Editor for Description */}
        <div className="ckeditor-container">
          <label>
            <h6>Description</h6>
          </label>
          <HTMLEditor
            value={editorContent}
            onChange={handleEditorChange}
            height="600px"
            placeholder="Start typing your news content..."
            onSave={handleSave}
            enableImageUpload={true}
            enableContextMenu={true}
            theme="light"
            userId="679086ffffb3896f0da4b84a"
          />
        </div>
        <label>
          <h6>News Category</h6>
        </label>
        <input
          type="text"
          name="news_category"
          value={newsData.news_category}
          onChange={handleChange}
          placeholder="Enter News Category"
          className="form-control"
        />
        <label>
          <h6>Slug Url</h6>
        </label>
        <input
          type="text"
          name="slug_url"
          value={newsData.slug_url}
          onChange={handleChange}
          placeholder="Enter model type"
          className="form-control"
        />
        <label>
          <h6>Meta Title</h6>
        </label>
        <input
          type="text"
          name="meta_title"
          value={newsData.meta_title}
          onChange={handleChange}
          placeholder="Enter Meta tags"
          className="form-control"
        />
        <label>
          <h6>Meta Description</h6>
        </label>
        <input
          type="text"
          name="meta_description"
          value={newsData.meta_description}
          onChange={handleChange}
          placeholder="Enter Meta tags"
          className="form-control"
        />
        <label>
          <h6>Meta keyword</h6>
        </label>
        <input
          type="text"
          name="meta_keywords"
          value={newsData.meta_keywords}
          onChange={handleChange}
          placeholder="Enter Meta tags"
          className="form-control"
        />
        <label>
          <h6>Source</h6>
        </label>
        <input
          type="text"
          name="source"
          value={newsData.source}
          onChange={handleChange}
          placeholder="Enter Meta tags"
          className="form-control"
        />

        {/* Submit Button */}
        <div className="text-center mt-4">
          {newsId ? (
            <>
              <button className="btn btn-success me-2" onClick={handleUpdate}>
                Update
              </button>
              <button
                className="btn btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/News");
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-secondary me-2"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/News");
                }}
              >
                Back
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Save
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateNews;
